import React, { Component } from 'react'
import ClientLineItem from '../../../Domain/ClientLineItem';
import ShowEntityData from '../../../Elements/ShowEntityData';
import ClientLineItemService from '../../../Services/ClientLineItemService';

export class ClientLineItemDetailsInfoTab extends Component {
    static defaultProps = {};

    constructor(props) {
        super(props);
        const urlParams = new URLSearchParams(window.location.search);
        this.lineItemId = urlParams.get('id');
    }

    render() {
        return (
          <ShowEntityData
            itemId={this.lineItemId}
            entityName='Line Item Details'
            type={ClientLineItem}
            serviceGetByIdFunction={ClientLineItemService.GetById}
          />
        );
    }
}

export default ClientLineItemDetailsInfoTab